import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { SonicTermData } from "../classes/SonicTerm";
import SearchTermInput from "./SearchTermInput";
import SelectTermItem from "./SelectTermItem";
import styles from "./SelectTerm.module.scss";
import LoadingSpinner from "../LoadingSpinner";

type Props = {
  isModalShown: boolean;
  isLoading: boolean;
  termName: string;
  handleSearch: (keyword: string) => void;
  handleClose: () => void;
  handleSelect: (value: SonicTermData) => void;
  handleDeselect?: () => void;
  selectedTerm?: SonicTermData;
  options?: Array<SonicTermData>;
  helpLink?: React.ReactNode;
};
const SelectTermModal: React.FC<Props> = ({
  isModalShown,
  isLoading,
  termName,
  handleSearch,
  handleClose,
  handleSelect,
  handleDeselect,
  selectedTerm,
  options,
  helpLink,
}) => {
  const [keyword, setKeyword] = useState<string>("");

  const [confirmInput, setConfirmInput] = useState<boolean>(true);
  const handleKeys = (event: React.KeyboardEvent<HTMLInputElement>) => {
    switch (event.key) {
      case "Enter":
        if (confirmInput) {
          event.preventDefault();
          handleSearch(keyword);
        }
        break;
      default:
        break;
    }
  };

  const clearSearch = () => {
    setKeyword("");
    handleSearch("");
  };

  return (
    <>
      {isModalShown ? (
        <div className={`${styles["select-term__modal"]} ${styles["open"]}`}>
          <p className={styles["select-term__modal-intro"]}>
            {`${termName}を選択してください。`}
          </p>
          {isLoading ? (
            <LoadingSpinner space={1} />
          ) : (
            <>
              <SearchTermInput
                termName={termName}
                keyword={keyword}
                handleKeys={handleKeys}
                setKeyword={setKeyword}
                setConfirmInput={setConfirmInput}
                handleSearch={() => {
                  handleSearch(keyword);
                }}
                clearSearch={clearSearch}
              />
              <div className={styles["select-term__modal-area"]}>
                {options ? (
                  <>
                    {handleDeselect ? (
                      <div className={styles["undecided-option-wrapper"]}>
                        <div
                          className={styles["undecided-option"]}
                          onClick={() => {
                            handleDeselect();
                            clearSearch();
                          }}
                        >
                          <i>
                            <FontAwesomeIcon icon={["fas", "times"]} />
                          </i>
                          <div>選択を外す</div>
                        </div>
                      </div>
                    ) : null}
                    {options.map((option, i) => (
                      <SelectTermItem
                        key={i}
                        type={"select"}
                        terms={selectedTerm ? [selectedTerm] : undefined}
                        term_option={option}
                        selectHandler={(value: SonicTermData) => {
                          handleSelect(value);
                          clearSearch();
                        }}
                      />
                    ))}
                  </>
                ) : null}
              </div>
            </>
          )}
          <div className={styles["select-term__modal__bottom"]}>
            <button
              type="button"
              className={styles["select-term__modal__bottom-back"]}
              onClick={() => {
                clearSearch();
                handleClose();
              }}
            >
              閉じる
            </button>

            {helpLink ? (
              <div className={styles["select-term__modal__bottom-help"]}>
                {helpLink}
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default SelectTermModal;
